module.exports = __webpack_public_path__ + "img/360 Fm.0c5c479a.png";